var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'bg-gray30': _vm.isEducation}},[_c('account-header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"container p-x-1:mo m-b-3 m-b-6:t"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }